<template>
  <div :class="{'m-grid__item m-grid__item--order-tablet-and-mobile-2 m-login__aside p-lg-5': login}">
    <div :class="{'m-stack m-stack--hor m-stack--desktop': login}">
      <div :class="{'m-stack__item m-stack__item--fluid': login}">
        <div class="m-subheader " v-if="!contact_us && !login">
          <div class="d-flex align-items-center">
            <div class="mr-auto">
              <ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
		  		    	<li class="m-nav__item">
		  		    		<router-link :to="{name: 'home'}">
		  		    			<span class="m-nav__link-text">
                      <i class="m-nav__link-icon la la-home"></i>
                    </span>
		  		    		</router-link>
		  		    	</li>
		  		    	<li class="m-nav__separator">
		  		    		>
		  		    	</li>
		  		    	<li class="m-nav__item">
		  		    		<a href="" class="m-nav__link">
		  		    			<span class="m-nav__link-text">
		  		    				{{'contact' | translate | titleize}}
		  		    			</span>
		  		    		</a>
		  		    	</li>
		  		    </ul>
            </div>
          </div>
        </div>
        <div class="m-content">
          <div :class="{'m-portlet m-portlet--tab': !login, 'm-portlet m-portlet--last m-portlet--tab': login}">
            <div class="m-portlet__head" v-if="contact_us || login">
              <div class="m-portlet__head-caption">
                <div class="m-portlet__head-title">
                  <span class="m-portlet__head-icon m--hide">
                    <i class="la la-gear"></i>
                  </span>
                  <h3 class="m-portlet__head-text">
                    {{ 'contact' | titleize }}
                  </h3>
                </div>
              </div>
            </div>
            <form @submit.prevent="validateFromContact()" class="m-form m-form--state m-form--fit m-form--label-align-right">
              <div class="m-portlet__body">
                <div class="form-group m-form__group m--margin-top-10">
                  <div class="alert m-alert m-alert--default" role="alert">
                    {{ 'contact_instructions_text' | capitalize }}
                  </div>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger' :errors.has('name')}">
                  <label for="contact_name">
                    {{ 'full_name' | capitalize }}
                  </label>
                  <input v-validate="'required'" type="text" name="name" class="form-control m-input" id="contact_name" :placeholder="'enter_your_name' | capitalize" v-model="contact_name">
                  <span v-show="errors.has('name')" class="m-form__help m--font-danger">
                  {{ errors.first('name') }}
                  </span>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger' :errors.has('subject')}">
                  <label for="contact_subject">
                    {{ 'subject' | capitalize }}
                  </label>
                  <select v-validate="'required'" name="subject" class="form-control m-input" id="contact_subject" v-model="contact_subject">
                    <option value="">
                      {{ 'select_subject' | capitalize }}
                    </option>
                    <option v-for="(subject, index) in subjects" :key="index">
                      {{ subject.name | capitalize }}
                    </option>
                  </select>
                  <span v-show="errors.has('subject')" class="m-form__help m--font-danger">
                  {{ errors.first('subject') }}
                  </span>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger' :errors.has('email')}">
                  <label for="contact_email">
                    {{ 'email' | capitalize }}
                  </label>
                  <input v-validate="'required|email'" type="email" name="email" class="form-control m-input" id="contact_email" v-model="contact_email" :placeholder="'enter_your_email' | capitalize">
                  <span v-show="errors.has('email')" class="m-form__help m--font-danger">
                    {{ errors.first('email') }}
                  </span>
                </div>
                <a id="center_contact_form" href=""> </a>
                <div class="form-group m-form__group" :class="{'has-danger' :errors.has('message')}">
                  <label for="contact_message">
                    {{ 'message' | capitalize }}
                  </label>
                  <textarea v-validate="'required'" name="message" class="form-control m-input" id="contact_message"  rows="5" v-model="contact_message" :placeholder="'enter_your_message' | capitalize"></textarea>
                  <span v-show="errors.has('message')" class="m-form__help m--font-danger">
                    {{ errors.first('message') }}
                  </span>
                </div>
              </div>
              <div class="m-portlet__foot m-portlet__foot--fit m--align-right">
                <div class="m-form__actions">
                  <button type="submit" class="btn btn-primary">
                    {{ 'send' | capitalize }}
                  </button>
                  <button type="button" class="btn btn-secondary" @click="removeContact">
                    {{ 'cancel' | capitalize }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      subjects: [],
      contact_email: '',
      contact_subject: '',
      contact_message: '',
      contact_name: ''
    }
  },
  props: {
    contact_us: { type: Boolean, required: false, default: false },
    login: { type: Boolean, required: false, default: false }
  },
  created () {
    this.$store.dispatch('getSubject', {outside: this.contact_us, language: this.$i18n.locale})
      .then((response) => {
        if (response.data.status === 200) {
          this.subjects = response.data.content
        }
      })
  },
  mounted () {
    document.getElementById('center_contact_form').focus(function () {
      var center = window.height() / 2
      if (top > center) {
        window.scrollTop(top - center)
      }
    })
  },
  methods: {
    validateFromContact () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$spinner.show()
          this.$store.dispatch('sendEmail', {'email': this.contact_email, 'subject': this.contact_subject, 'message': this.contact_message, 'name': this.contact_name, language: this.$i18n.locale})
            .then((response) => {
              if (response.data.message === 'success') {
                this.$spinner.remove()
                this.$toast('contact_send_message', 1)
                if (this.login) {
                  this.$router.push({ path: '/login' })
                } else {
                  this.$router.push({ path: '/' })
                }
              } else {
                this.$spinner.remove()
                this.$toast('contact_send_error', 4)
              }
            })
            .catch(() => {
              this.$spinner.remove()
              this.$toast('contact_send_error', 4)
            })
        }
      })
    },
    removeContact () {
      if (!this.contact_us) {
        if (this.login) {
          this.$router.push({ path: '/login' })
        } else {
          this.$router.push({ path: '/' })
        }
      } else {
        this.$emit('removeContact')
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Contacts.vue